// extracted by mini-css-extract-plugin
export default {"promo":"cqho3Ywni"};